// cart-drawer-toggle.js — unified PBCart + header badge & subtotal sync
(function () {
  const PRIMARY_SELECTOR = '[data-pb-cart-drawer="primary"]';
  const DRAWER_TRANSITION_MS = 380;

  function getPrimaryDrawer() {
    return (
      document.querySelector(PRIMARY_SELECTOR) ||
      document.getElementById('UnifiedCartDrawer')
    );
  }

  function removeDuplicateDrawers(primary) {
    if (!primary) return;

    document.querySelectorAll('.unified-cart-drawer').forEach((el) => {
      if (el === primary) return;
      el.remove();
    });
  }

  function init() {
    if (window.__pbCartDrawerToggleInit) return;
    window.__pbCartDrawerToggleInit = true;

    const drawer = getPrimaryDrawer();
    if (!drawer) return;

    removeDuplicateDrawers(drawer);

    let backdrop = document.querySelector('.ucd-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'ucd-backdrop';
      document.body.appendChild(backdrop);
    }

    let scrollY = 0;
    let closeTimer = 0;

    // The lock goes on <html> ONLY. `overflow: hidden` on <body> as well used
    // to turn the body into a scroll container of its own, and every
    // `position: sticky` element on the page then sticks to the body instead
    // of the viewport — on the pre-sale page the hero and the picker column
    // jumped off the top of the screen the moment the drawer opened. The
    // viewport's overflow comes from <html> here, so <html> alone locks it.
    function lockScroll() {
      scrollY = window.scrollY;
      document.documentElement.style.overflow = 'hidden';
    }

    function unlockScroll() {
      document.documentElement.style.overflow = '';
      window.scrollTo(0, scrollY);
    }

    function preserveScrollPosition() {
      window.scrollTo(0, scrollY);
    }

    // `reason` is een string bij onze eigen calls en een Event wanneer dit als
    // listener op `cart:open` hangt — pb-cart.js hangt daar `detail.source` aan
    // zodat een mandje dat vanzelf opensprong na een add te onderscheiden is van
    // een shopper die zelf op het mandje klikte.
    function openReason(reason) {
      if (typeof reason === 'string') return reason;
      return (reason && reason.detail && reason.detail.source) || 'manual';
    }

    function openDrawer(reason) {
      if (drawer.classList.contains('is-open')) return;

      window.PBUnifiedNavOverlay?.closeAll();
      window.closeSearchPopup?.();
      window.PBOffersDrawer?.close?.();

      window.clearTimeout(closeTimer);
      scrollY = window.scrollY;
      lockScroll();

      if (window.PBOverlayStack) {
        window.PBOverlayStack.push(backdrop);
        window.PBOverlayStack.push(drawer);
      }

      preserveScrollPosition();

      document.documentElement.classList.add('ucd-cart-open');
      document.body.classList.add('ucd-cart-open');

      requestAnimationFrame(() => {
        void drawer.offsetWidth;
        backdrop.classList.add('is-visible');
        drawer.classList.add('is-open');
        preserveScrollPosition();
      });

      // Pas hier, want een open op een al open drawer keert hierboven om: wie
      // hierop luistert (pb-cart-view-tracking.js) hoort dus alleen de opens
      // waarbij de shopper zijn mandje ook echt te zien krijgt.
      document.dispatchEvent(
        new CustomEvent('pb:cart:drawer:opened', { detail: { source: openReason(reason) } })
      );
    }

    function finishClose() {
      if (window.PBOverlayStack) {
        window.PBOverlayStack.pop(drawer);
        window.PBOverlayStack.pop(backdrop);
      }
      unlockScroll();
    }

    function closeDrawer() {
      if (!drawer.classList.contains('is-open')) return;

      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-visible');

      let finished = false;
      const complete = () => {
        if (finished) return;
        finished = true;
        drawer.removeEventListener('transitionend', onTransitionEnd);
        window.clearTimeout(closeTimer);
        document.documentElement.classList.remove('ucd-cart-open');
        document.body.classList.remove('ucd-cart-open');
        finishClose();
      };

      const onTransitionEnd = (event) => {
        if (event.target !== drawer || event.propertyName !== 'right') return;
        complete();
      };

      drawer.addEventListener('transitionend', onTransitionEnd);
      closeTimer = window.setTimeout(complete, DRAWER_TRANSITION_MS);
    }

    function toggleDrawer() {
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    }

    window.PBGetCartDrawer = getPrimaryDrawer;
    window.PBCartDrawer = { open: openDrawer, close: closeDrawer, toggle: toggleDrawer };

    drawer.querySelector('.cart-drawer__close')?.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    document.addEventListener('cart:open', openDrawer);
    document.addEventListener('cart:close', closeDrawer);
    document.addEventListener('cart:toggle', toggleDrawer);

    const cartTriggerSelectors = [
      '[data-pb-cart-drawer-toggle]',
      '#pb-unified-nav-cart-icon',
      '#cart-icon-bubble',
      '.pb-unified-nav__cart',
      '.pb-top-bar__cart',
      '.header-actions__action.action__cart',
      '.header__icon--cart',
      '.header__cart',
      'button[data-open-cart]',
      '[data-header-cart]',
      '[data-cart-toggle]',
    ];

    const boundCartTriggers = new WeakSet();
    cartTriggerSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((trigger) => {
        if (boundCartTriggers.has(trigger)) return;
        boundCartTriggers.add(trigger);
        trigger.addEventListener('click', (ev) => {
          ev.preventDefault();
          openDrawer();
        });
      });
    });

    // Use the cart's own currency: carts in a non-EUR market (SE, DK) return SEK/DKK.
    function formatMoney(amount, currency = 'EUR') {
      try {
        return new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency,
        }).format(amount);
      } catch {
        const value = amount.toFixed(2).replace('.', ',');
        return currency === 'EUR' ? `€${value}` : `${currency} ${value}`;
      }
    }

    document.addEventListener('pb:cart:updated', (e) => {
      const gqlCart = e.detail?.cart;

      // pbSuppressDrawer: set by assets/powr-card.js, which shows a toast instead.
      if ((e.detail?.source === 'addLine' || e.detail?.source === 'add') && !e.detail?.pbSuppressDrawer) {
        setTimeout(() => openDrawer('after_add'), 60);
      }

      const countEl = document.querySelector('[data-cart-count],[data-header-cart-count]');
      if (countEl && gqlCart?.totalQuantity != null) {
        countEl.textContent = gqlCart.totalQuantity;
      }

      const subEl = document.querySelector('[data-cart-subtotal]');
      const sub = gqlCart?.cost?.subtotalAmount;
      if (subEl && sub?.amount) {
        subEl.textContent = formatMoney(parseFloat(sub.amount), sub.currencyCode || 'EUR');
      }
    });

    const qs = new URLSearchParams(location.search);
    if (qs.get('viewcart') === 'true' || qs.get('cartopen') === 'true') openDrawer('url_param');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
